module.exports = __webpack_public_path__ + "img/logo.b4a657e0.png";